<template>
   <div class="">
    <button class="mr-3 btn " 
        :style="[(data.isSupplyAccepted || data.isSupplyRejected) ? {cursor: 'not-allowed'} : null]" 
        @click="!data.isSupplyAccepted ? acceptSupply() : null"  
        :class="[!data.isSupplyAccepted ? 'btn-success' : 'btn-warning']"
        :disabled="(data.isSupplyAccepted || data.isSupplyRejected) ? true : false"
    >
        {{!data.isSupplyAccepted ? 'Accept supply' : 'Supply accepted'}}
    </button>
    <router-link  class="mr-3 btn btn-info" :to="{name: 'BranchSupplyDetails', query: {supplyId: data.id, companyId: $route.query.companyId, branchId: $route.query.branchId}}">
      {{$t('text.clickButtons.details')}}
    </router-link>
    <button  class="mr-3 btn btn-danger" :style="[data.isSupplyRejected ? {cursor: 'not-allowed'} : null]" 
        @click="!data.isSupplyRejected ? rejectSupply() : null"  
        :class="[!data.isSupplyRejected ? 'btn-success' : 'btn-warning']"
        :disabled="data.isSupplyRejected ? true : false">
        {{!data.isSupplyRejected ? 'Reject supply' : 'Supply rejected'}}
    </button> 
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
    acceptSupply() {
        const deleteConfirm = window.confirm("Are you sure you want to accept this supply?");
        if(deleteConfirm){
            this.axios.post(`${configObject.apiBaseUrl}​/NonWetProductSupply/AcceptSupply/${this.data.branchId}/${this.data.id}`, {},  configObject.authConfig())
                .then(() => {                
                    this.$toast.open({
                        message: "Successfully accepted  supply",
                        type: 'success',
                        duration: 5000
                    });
                    this.$eventHub.$emit("renderNonWetProductSupplies")
                }).catch(error => {       
                  this.$toast.open({
                      message: error.response.data.message ,
                      type: 'error',
                      duration: 5000
                  });
              });
        }
    },
    rejectSupply() {
     this.$eventHub.$emit("_rejectSupply", this.data)
    }
  },
};

</script>